import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoSparkles } from "react-icons/io5";
import { FaCar } from "react-icons/fa";
import { MdElectricalServices } from "react-icons/md";
import { GiClayBrick } from "react-icons/gi";
import { GiTripleScratches } from "react-icons/gi";
import { FaHandSparkles } from "react-icons/fa";
import "./PaintCorrection.css";
function PaintCorrection() {
  return (
    <div className="package-info">
      {/* all sections */}

      <>
        <section className="service-hero">
          <div className="service-content">
            <span className="service-tag">PREMIUM DETAILING SERVICE</span>

            <h1>Paint Correction</h1>

            <p className="service-description">
              Swirl marks, light scratches, oxidation, and dull paint can make
              an otherwise clean vehicle look worn. Paint correction improves
              the clarity and shine of your vehicle&apos;s finish by carefully
              polishing away visible imperfections while restoring depth and
              gloss.
            </p>
          </div>

          <div className="service-image">
            <img src="/images/paint.png" alt="Paint Correction" />
          </div>
        </section>

        <section className="service-cards">
          <div className="card">
            <div className="card-header">
              {/* Icon */}
              <IoSparkles color="#f703ff" />
              <h2>Improves</h2>
            </div>

            <ul className="icon-list">
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Swirl marks</span>
              </li>
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Light scratches</span>
              </li>
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Water spots</span>
              </li>
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Oxidation</span>
              </li>
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Hazy or dull paint</span>
              </li>
              <li>
                {/* Icon */}
                <IoIosCheckmarkCircle color="#f703ff" />
                <span>Reduced gloss and clarity</span>
              </li>
            </ul>
          </div>

          <div className="card">
            <div className="card-header">
              {/* Icon */}
              <FaCar color="#f703ff" />
              <h2>What's Included</h2>
            </div>

            <div className="two-column-list">
              <div>
                <div className="feature">
                  {/* Icon */}
                  <FaHandSparkles color="#f703ff" />
                  <span>Full hand wash</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <GiClayBrick color="#f703ff" />
                  <span>Clay bar</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <MdElectricalServices color="#f703ff" />
                  <span>Multi-step polishing</span>
                </div>

                <div className="feature">
                  {/* Icon */}
                  <GiTripleScratches color="#f703ff" />
                  <span>Scratch reduction</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="service-note">
          <div className="note-content">
            {/* Info Icon */}

            <div className="note-text">
              <h3>Important</h3>
              <p>
                Paint correction results depend on the depth of the damage and
                the condition of the paint. An inspection may be required before
                an exact quote can be provided.
              </p>
            </div>
          </div>
        </section>
      </>
    </div>
  );
}
export default PaintCorrection;
